import styled from 'styled-components'

const PopoverPickerStyle = styled.div`
  position: relative;
  margin-left: 30px;
  margin-top: 7%;
  .swatch {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 3px solid #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
  .popover {
    position: absolute;
    top: calc(80% + 6px);
    right: 0;
    border-radius: 9px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  .react-colorful {
    height: auto !important;
    border-radius: 6px !important;
  }
  .react-colorful__saturation {
    display: none;
  }
  .react-colorful__hue {
    border-radius: 6px !important;
    background: linear-gradient(
      90deg,
      #8d1c1f,
      #8f8c2a,
      #228d34,
      #218e87,
      #2c228b,
      #8d2186,
      #8e1b1f
    ) !important;
  }
  .react-colorful__pointer-fill {
    background-color: ${props => props.pointerColor} !important;
    &[style] {
      background-color: ${props => props.pointerColor} !important;
    }
  }
`

export default PopoverPickerStyle



// WEBPACK FOOTER //
// ./src/components/colorpicker/PopoverPickerStyle.js